const Required = Object.freeze({
  Email: 'Email is required',
  Password: 'Password is required',
});

export default Required;
